import { ArrowLeft } from "lucide-react";
import type { FulfillmentReturnContext } from "@/lib/fulfillmentReturn";

interface FulfillmentReturnLinkProps {
  context: FulfillmentReturnContext;
  className?: string;
}

/** Secondary exit from in-flow fulfillment UI back to the parent surface. */
export function FulfillmentReturnLink({ context, className = "" }: FulfillmentReturnLinkProps) {
  return (
    <button
      type="button"
      onClick={context.onReturn}
      className={`inline-flex items-center gap-1.5 text-sm font-semibold text-navy transition-colors hover:text-coral focus:outline-none focus:ring-2 focus:ring-coral/40 rounded ${className}`}
    >
      <ArrowLeft className="h-4 w-4 shrink-0" aria-hidden />
      {context.label}
    </button>
  );
}
